import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-loading-report',
    templateUrl: './loading-report.component.html',
    standalone: false
})
export class LoadingReportComponent implements OnInit {
  constructor() {}
  win: any;
  canClose = true;

  ngOnInit() {
    setTimeout(() => {
      this.win = window['selfRef'];
      this.canClose = this.win !== undefined;
    }, 100);
  }

  closeSelf = () => {
    if (this.canClose) {
      this.win.close();
    }
  };
}
